import { ResourcePackage } from "./feature/core/resource/resource.module";

export const resourcePackage: ResourcePackage = {
  "hu": {
    "mkb.card3dsecure.common.lang.hu": "Magyar",
    "mkb.card3dsecure.common.lang.en": "Englsih"
  },
  "en": {
    "mkb.card3dsecure.common.lang.hu": "Magyar",
    "mkb.card3dsecure.common.lang.en": "Englsih"
  }
};
